import { getOrganization } from '@awin/shared/auth0-helper';

export const environment = {
  name: 'staging',
  loadDarwinAlerts: true,
  loadDarwinNavigation: true,
  production: true,
  staging: false,
};

export const appName = 'Communication Centre';
export const appPath = '/communication-centre';

export const awinGatewayBaseUrl = window.origin;
export const cloudGatewayBaseUrl = 'https://ui.staging.awin.com/backend';
export const cloudFrontBaseUrl = 'https://ui.dev.communication-centre.awin.com';

export const eventSourceEnabled = false;
export const preferencesLinkEnabled = true;
export const previewCaptureEnabled = true;

export const forceAuthorizationRefreshAfterMs = false;

export const googleAnalytics = {
  enabled: true,
  debugEvents: false,
  trackingId: 'UA-1462819-6',
  urlPrefix: appPath,
  ignoreRoutes: [],
};

export const endPoints: { [id: string]: string } = {
  darwinSession: `/navigation/session/`,
  jwksUrl: `/backend/idpbackend/.well-known/jwks.json`,
};

export const auth0ClientId = 'mIeGsIpdZEXbqcaZyGYKTss0KdOwjo07';
export const organizationValue = null;
export const authRefreshTokenTimeoutFactor = 0.75;
